import { useEffect, useState } from "react";
import Image from "next/legacy/image";
import styles from "../styles/pujaItem.module.css";
import { trackEvent } from "@utils/analytics/event-analytics";
import { useRouter } from "next/router";
import { WEB_ENGAGE } from "@utils/constants";
import { formatNumber, prettyDate } from "@utils/metrics/timeFunction";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Temple from "@public/assets/icons/templehindu_20.svg";
import { useTranslation } from "react-i18next";
import { Divider, Typography, useMediaQuery } from "@mui/material";
import CustomizedButton from "src/globalModule/components/button";
export default function PujaItem({
  data,
  index,
  position
}) {
  const router = useRouter();
  const [eventUrl, setEventUrl] = useState("");
  const {
    t
  } = useTranslation();
  const smallScreen = useMediaQuery("(max-width:768px)");
  useEffect(() => {
    const referrer = router.query.referrer;
    const utm_source = router.query.utm_source;
    const utm_medium = router.query.utm_medium;
    const utm_campaign = router.query.utm_campaign;
    const utm_content = router.query.utm_content;
    if (data.urlExtension) {
      let deityTypeName = data.EventDeityTypes?.[0]?.DeityType?.name;
      let redirectedUrl = "";
      if (deityTypeName) {
        redirectedUrl = `/puja/${deityTypeName}/${data.urlExtension}`;
        // setEventUrl(
        //   `/puja/${deityTypeName}/${data.urlExtension}?${
        //     position ? "utm_source=" + position + "&" : ""
        //   }utm_medium=${smallScreen ? "mobile_web" : "desktop_web"}`
        // );
      } else {
        redirectedUrl = `/puja/${data.urlExtension}`;
        // setEventUrl(
        //   `/puja/${data.urlExtension}?utm_source=${position}&utm_medium=${
        //     smallScreen ? "mobile_web" : "desktop_web"
        //   }`
        // );
      }
      const queryParams = new URLSearchParams();
      if (utm_source) queryParams.append("utm_source", utm_source);
      if (utm_medium) queryParams.append("utm_medium", utm_medium);
      if (utm_campaign) queryParams.append("utm_campaign", utm_campaign);
      if (utm_content) queryParams.append("utm_content", utm_content);
      if (referrer) queryParams.append("referrer", referrer);
      if (queryParams.toString()) {
        redirectedUrl += `?${queryParams.toString()}`;
      }
      setEventUrl(redirectedUrl);
    }
  }, [data, smallScreen]);
  return <div className={`${styles.root} `} data-sentry-component="PujaItem" data-sentry-source-file="pujaItem.jsx">
      {data?.images?.length > 0 && <div className={styles.event_image_container} onClick={e => {
      e.preventDefault();
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST + " " + WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST,
        [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD,
        [WEB_ENGAGE.EVENT_PROPERTIES.CLICK_ELEMENT]: WEB_ENGAGE.CLICK_ELEMENTS.IMAGE,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: data?.EventDeityTypes[0]?.DeityType?.name,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
      });
      router.push(eventUrl, undefined, {
        locale: router.locale
      });
    }}>
          <Image src={data.images[0]} alt={data.name + ` ${t("utsav-kriya")}`}
      // width={"100%"}
      // height={"100%"}
      layout="fill" objectFit="cover" placeholder="blur" blurDataURL={data.images[0]} />
        </div>}

      <div className={styles.event_body}>
        <div className={styles.event_card_head}>
          <Typography className={styles.event_name} onClick={() => {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST + " " + WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST,
            [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD,
            [WEB_ENGAGE.EVENT_PROPERTIES.CLICK_ELEMENT]: WEB_ENGAGE.CLICK_ELEMENTS.NAME,
            [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: data?.EventDeityTypes[0]?.DeityType?.name,
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
          });
          router.push(eventUrl, undefined, {
            locale: router.locale
          });
        }} data-sentry-element="Typography" data-sentry-source-file="pujaItem.jsx">
            {data.name}
          </Typography>

          {/* {data.avgRating ? (
            <div className={styles.rating_holder}>
              <StarRateRounded style={{ color: "white", height: "20px" }} />
              <p>{data.avgRating}</p>
            </div>
           ) : (
            ""
           )} */}
        </div>

        <div className={styles.pujaDateTempleHolder}>
          {data?.start && <div className={styles.pujaDateTemple}>
              <CalendarMonthIcon sx={{
            color: "#ff5757"
          }} />
              <span>
                {prettyDate(new Date(Number(data?.start)), router.locale)}
                {data?.EventFestivalTimelines?.length > 0 && <>
                    {" "}
                    - {data?.EventFestivalTimelines[0]?.FestivalTimeline?.title}
                  </>}
              </span>
            </div>}

          {data?.templeName && <div className={styles.pujaDateTemple}>
              <span className={styles.templeIconHolder}>
                <Temple />
              </span>
              <span>{data.templeName}</span>
            </div>}
        </div>
      </div>

      <Divider sx={{
      opacity: 0.25
    }} data-sentry-element="Divider" data-sentry-source-file="pujaItem.jsx" />

      <div className={styles.event_card_button}>
        <div className={styles.participant_no}>
          {formatNumber(data.participantNo)} {t("have-booked")}
        </div>

        <div className={styles.view_details_btn_container} onClick={e => {
        e.preventDefault();
        trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST + " " + WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_LIST,
          [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.KRIYA_CARD,
          [WEB_ENGAGE.EVENT_PROPERTIES.CLICK_ELEMENT]: WEB_ENGAGE.CLICK_ELEMENTS.BUTTON,
          [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
          [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: data?.EventDeityTypes[0]?.DeityType?.name,
          [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
        });
        router.push(eventUrl, undefined, {
          locale: router.locale
        });
      }}>
          {/* <button>{t("Book Puja")}</button> */}
          <CustomizedButton btnText={t("Book Puja")} data-sentry-element="CustomizedButton" data-sentry-source-file="pujaItem.jsx" />
        </div>
      </div>
    </div>;
}